<template>
    <div class="version-list">
        <page-title></page-title>
        <div class="container">
            <el-table 
                :data="tableData" 
                v-loading="loading">
                <el-table-column label="版本名称" prop="version_number"></el-table-column>
                <el-table-column label="版本号" prop="real_version_number"></el-table-column>
                <el-table-column label="更新内容" prop="version_desc"></el-table-column>
                <el-table-column label="更新时间" prop="created_at"></el-table-column>
                <el-table-column label="状态">
                    <template #default="scope">
                        <el-tag type="danger" v-if="scope.row.status == 0">禁用</el-tag>
                        <el-tag v-else>启用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80px">
                    <template #default="scope">
                        <el-button type="text" @click="setStatus(scope.row)" v-if="scope.row.status == 0">启用</el-button>
                        <el-button type="text" style="color: #909399;" @click="setStatus(scope.row)" v-else>禁用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    layout="total, prev, pager, next"
                    v-model:currentPage="p"
                    :total="count"
                    @current-change="getList">
                </el-pagination>
            </div> 
        </div>
    </div>
</template>

<script>
import pageTitle from '@/components/page-title/index.vue';

export default {
    components: {
        pageTitle
    },
    data() {
        return {
            appId: this.$route.query.id,
            tableData: [],
            p: 1,
            limit: 10,
            loading: false,
            svg: `
                <path class="path" d="
                M 30 15
                L 28 17
                M 25.61 25.61
                A 15 15, 0, 0, 1, 15 30
                A 15 15, 0, 1, 1, 27.99 7.5
                L 15 15
                " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
            `,
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            this.loading = true;
            const res = await this.$api.appVersionList({
                app_id: this.appId,
                p: this.p,
                limit: this.limit
            });
            this.loading = false;
            if(res.data.code == 0) {
                this.tableData = res.data.data.list;
                this.count = res.data.data.count;
            }
        },
        async setStatus(row) {
            const res = await this.$api.appVersionStatus({
                id: row.id,
                status: row.status == 1 ? 0 : 1
            });
            if(res.data.code == 0) {
                this.$message({
                    type: 'success',
                    message: '修改成功'
                });
                this.getList();
            }
        }
    }

}
</script>